import { render } from "./App.vue?vue&type=template&id=626d099a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=626d099a&lang=css"

import exportComponent from "D:\\开发文件夹\\网上营业厅开发\\obh-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__